import { render, staticRenderFns } from "./MailingType.vue?vue&type=template&id=dc559f8e"
import script from "./MailingType.vue?vue&type=script&lang=js"
export * from "./MailingType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports